import { Autocomplete, Grid, TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

const thaiMonths = [
  { label: "มกราคม", value: 1 },
  { label: "กุมภาพันธ์", value: 2 },
  { label: "มีนาคม", value: 3 },
  { label: "เมษายน", value: 4 },
  { label: "พฤษภาคม", value: 5 },
  { label: "มิถุนายน", value: 6 },
  { label: "กรกฎาคม", value: 7 },
  { label: "สิงหาคม", value: 8 },
  { label: "กันยายน", value: 9 },
  { label: "ตุลาคม", value: 10 },
  { label: "พฤศจิกายน", value: 11 },
  { label: "ธันวาคม", value: 12 },
];
const DateMonthYearSelector = ({ key, onDateChange }) => {
  const [day, setDay] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [error, setError] = useState({
    day: {
      error: false,
      message: "",
    },
    month: {
      error: false,
      message: "",
    },
    year: {
      error: false,
      message: "",
    },
  });

  // คำนวณจำนวนวันในเดือน / ปีที่เลือก;
  const dayOptions = useMemo(() => {
    if (month && year) {
      const monthIndex = thaiMonths.indexOf(month);
      const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
      console.log("daysInMonth", daysInMonth);
      return Array.from({ length: daysInMonth }, (_, i) => i + 1);
    }
    return Array.from({ length: 31 }, (_, i) => i + 1);
  }, [month, year]);

  useEffect(() => {
    if (day && month && year) {
      handleChangeAll({
        day,
        month,
        year,
      });
    }
  }, [day, month, year]);

  const handleChangeAll = ({ day, month, year }) => {
    // formatdate yyyy-mm-dd
    const formattedDate = `${year}-${String(month).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;
    console.log("Formatted Date:", formattedDate);
    onDateChange(formattedDate);
  };

  return (
    <Grid container spacing={2} alignItems="center" key={key}>
      <Grid item xs={4}>
        <Autocomplete
          fullWidth
          options={Array.from(
            { length: 50 },
            (_, i) => new Date().getFullYear() - i
          )}
          getOptionLabel={(option) => option.toString()}
          onChange={(event, value) => setYear(value)}
          value={year}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="ปี"
              sx={{
                "& .MuiOutlinedInput-root": {
                  bgcolor: "white",
                  height: "40px",
                },
              }}
            />
          )}
          sx={{ width: "100%" }}
        />
      </Grid>
      <Grid item xs={4}>
        <Autocomplete
          fullWidth
          options={thaiMonths}
          getOptionLabel={(option) => option.label}
          value={thaiMonths.find((m) => m.value === month) || null}
          onChange={(event, value) => {
            console.log("Selected month:", { event, value });
            setMonth(value?.value || null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="เดือน"
              sx={{
                "& .MuiOutlinedInput-root": {
                  bgcolor: "white",
                  height: "40px",
                },
              }}
            />
          )}
          sx={{ width: "100%" }}
        />
      </Grid>
      <Grid item xs={4}>
        <Autocomplete
          fullWidth
          id="day-selector"
          options={dayOptions}
          getOptionLabel={(option) => option.toString()}
          value={day}
          onChange={(event, value) => {
            setDay(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="วัน"
              sx={{
                "& .MuiOutlinedInput-root": {
                  bgcolor: "white",
                  height: "40px",
                },
              }}
            />
          )}
          sx={{ width: "100%" }}
          error={error.day.error}
          helperText={error.day.message}
        />
      </Grid>
    </Grid>
  );
};

export default DateMonthYearSelector;
